module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-precomposed-11b0087a54e25cb89d75846a857e07f8.png";